import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgRefreshLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M20.9194 9.33645C20.4234 7.5672 19.4431 5.96632 18.0857 4.70989C16.7284 3.45345 15.0465 2.58978 13.2242 2.21314C11.402 1.8365 9.50976 1.96161 7.75486 2.57477C5.99996 3.18794 4.45005 4.26545 3.27505 5.68932C2.10004 7.1132 1.34517 8.82848 1.09326 10.6472C0.84135 12.4659 1.10214 14.318 1.8469 16.0004C2.59165 17.6827 3.79165 19.1303 5.31555 20.1849C6.83945 21.2395 8.62842 21.8603 10.4864 21.9791C11.8899 22.0688 13.2973 21.8744 14.6218 21.408C15.9464 20.9416 17.1601 20.2131 18.1885 19.2671M23 5.97349L21.5396 10.4113L16.9782 8.99126"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgRefreshLarge.displayName = 'SvgRefreshLarge';
const RefreshLarge = withForgeIconProps(SvgRefreshLarge, {
  name: 'Refresh',
  usage: 'Use to reload or refresh a page or view.',
  related: 'update, new, recent',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default RefreshLarge;
